export enum SubscriptionRepetition {
    SINGLE = 'single',
    WEEKLY = 'weekly',
    BIWEEKLY = 'biweekly',
    MONTHLY = 'monthly',
}
